import { useQuery } from "@tanstack/react-query";
import { axios } from "lib/axios";
import queryString from "query-string";

export const getStructureTypesPaginated = ({ denominationId, filter }) => {
  return axios.get(
    `/denominations/${denominationId}/structure-types?${queryString.stringify(
      filter
    )}`
  );
};

export const useStructureTypesPaginated = ({
  denominationId,
  filter,
  config
} = {}) => {
  return useQuery({
    ...config,
    queryKey: [
      "structure-types-paginated",
      denominationId,
      JSON.stringify(filter)
    ],
    queryFn: () => getStructureTypesPaginated({ denominationId, filter }),
    enabled: !!denominationId
  });
};
